const alertTitleDefaultStyle = theme => ({
  '&.MuiAlertTitle-root': {
    fontFamily: theme.tokens.ComponentAlertTitleFontName,
    fontSize: theme.tokens.ComponentAlertTitleFontSize,
    fontWeight: theme.tokens.ComponentAlertTitleFontWeight,
    lineHeight: theme.tokens.ComponentAlertTitleFontLineHeight,
    color: theme.tokens.ComponentAlertTitleFontColor
  }
});
export default alertTitleDefaultStyle;